module.exports = __webpack_public_path__ + "static/media/question-mark.23da7e5a.svg";